import { CategoryVehicleModel } from './enumerations/category-vehicle-model.model';
import { Pageable } from './pageable.model';

export type ControlTowerScore = {
  score: number;
  percentChange: number | null;
  vehicles: VehicleWithIndicators[];
  indicators: IndicatorDetail[];
};

export type VehicleWithIndicators = {
  licensePlate: string;
  type: CategoryVehicleModel;
  indicators: KpiIndicator[];
  tireIndicators: KpiIndicator[] | null;
  vehicleDescription: string;
  vehicleId: string;
};

export type KpiIndicator = {
  name: string;
  value: number;
  percentChange: number | null;
  group: 'ONE' | 'TWO' | 'THREE' | 'FOUR' | 'FIVE' | 'SIX';
  lowEvents: number | null;
  mediumEvents: number | null;
  highEvents: number | null;
  uniqueEvents: number | null;
};

export type IndicatorDetail = {
  vehicleId: number;
  odometer: number;
  fuelConsumption: number;
  rpmGreen: number;
  rpmYellow: number;
  rpmRed: number;
  acceleratorPositionGreen: number;
  acceleratorPositionYellow: number;
  acceleratorPositionRed: number;
  brakePositionGreen: number;
  brakePositionYellow: number;
  brakePositionRed: number;
  kmPerLiter: number;
};

export type KpiScoreNameList = {
  truck: string[];
  implement: string[];
  onChassis: string[];
};

export const defaultValue: Readonly<ControlTowerScore> = {
  score: null,
  percentChange: null,
  vehicles: [],
  indicators: [],
};
